<template>
    <section>
      <div class="header-section">
        <div class="container has-text-left header-title">
          <div class="color-white ml-5 mb-4 ">{{ subtitle }}</div>
          <div class="pb-title ml-5 color-white">{{ title }}</div>
        </div>
      </div>
      <div class="container columns is-12" style="margin: auto;">
        <div class="column is-12 pb-0" >
  
          <div class="is-clickable my-5 column mr-2 is-flex colour-secondary-01 is-underlined bold-l2 pl-0" @click="$router.push('/consultant/my-resource-centre')">
              <b-icon
                  icon="menu-left"
                  custom-size="is-large"
                  style="font-size: 30px;"
              ></b-icon>
            <span>Back to My Resource Centre</span>
          </div>
  
            <!-- Breadcrumbs -->
            <div class="column py-0 ml-2 mr-2 pl-0">
              <b-breadcrumb
                  align="is-left"
              >
                  <b-breadcrumb-item tag='router-link' to="/consultant/my-resource-centre">Announcement</b-breadcrumb-item>
                  <b-breadcrumb-item active>{{ title }}</b-breadcrumb-item>
              </b-breadcrumb>
          </div>
        </div>
      </div>
  
      <div class="container is-multiline is-mobile is-tablet is-desktop column-article columns is-12" style="margin: auto;">
        <div class="column is-12-mobile is-12-tablet is-8-desktop px-0" >
  
            <!-- Article Content -->
            <span class="column left mt-4 mb-4 ml-2" >
              <span v-html="content" class="content"></span>
            </span>
          
        </div>
        <div class="column is-12-mobile is-12-tablet is-4-desktop is-multiline" >
          <div class="mt-6 publish-wrapper has-text-left">
            <div class="">Published On: <span class="text-dark-red is-uppercase">{{ article.attributes.date ? formatDate(article.attributes.date) : ''  }}</span></div>
            <div class="mt-3">Prepared By: <span class="text-dark-red ">AHAM CAPITAL</span></div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import dayjs from 'dayjs'
  export default {
      data(){
        return{
          article: [],
          content: '',
          url: '/../../../assets/img/footer_background.png',
          author: '',
          title: '',
          subtitle: '',
          data: '',
        };
      },
      methods: {
        formatDate(apiDate){
          return dayjs(apiDate).format('DD MMM YYYY');
        },
      },
      mounted(){
        this.$httpClientCMS({
          method: 'GET',
          url:'api/my-resource-centres?populate=*&filters[category]=Announcement&filters[id]=' + this.$route.params.id,
        })
        .then(resp =>{
          this.article = resp.data.data[0];
          this.content = this.article.attributes.content;
          this.author  = this.article.attributes.author
          this.title   = this.article.attributes.title
          this.subtitle    = this.article.attributes.subtitle
        })
      }
    }
  
  
  
  
  </script>
  
  <style scoped lang="scss">

  :deep() {
    .button.is-ghost {
      color: #FFFFFF !important;
    }
  }

  .header-section {
    background: url('../../../assets/img/footer_background.png');
    width: 100%;
    height: 500px;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: -6.5rem;
    display: flex;
    align-items: flex-end;
    .title {
      color: #FFF;
      text-align: left;
      margin-bottom: 5rem;
      margin-left: 6rem;
    }

    .header-title {
      margin-bottom: 4.6rem;
    }
  }
  .notification{
    background-color: white;
  }

  .column.left {
    padding-right: 5.4rem;
  }
  
  .section-spacing{
    margin-inline: 8em;
    width: 100%;
  }
  
  .publish-wrapper {
    background-color: #FFF;
    padding: 2rem;
    border-bottom: 5px solid #730039;
    .text-dark-red {
      font-weight: 700;
      color: #730039;
    }
  }
  .date{
    color: gray;
  }
  .title{
    font-weight: 700;
    font-size: 40px;
  }
  .author_name{
    color: blue;
  }
  .content{
    text-align: left;
  }
  .disclaimer{
    text-align: left;
    font-weight: 600;
  }
  .disclaimer_note{
    text-align: left;
    color: #363636;
    font-size: 1rem;
    line-height: 24px;
  }
  .button{
    float: left;
    // background-color: #9368AC;
  }
  .download{
    color: white;
  }
  
  @media screen and (max-width:1230px) {
    .publish-wrapper {
      padding: 1.3rem;
    }
  }
  
  @media screen and (max-width:1023px) {
  
    .header-section {
      height: 400px;
      background-position: center;
      
      .header-title {
        margin-bottom: 2.25rem;
        padding-left: 1.5rem !important;
        padding-right: 1.5rem !important;
        .ml-5 {
          margin-left: 0 !important;
          margin-bottom: 0.625rem !important;
        }
      }

    }
    :deep() {
      .breadcrumb {
        // margin-right: 10rem;
        ul {
          padding-left: 0 !important;
          overflow: hidden !important;
          flex-wrap: nowrap !important;
        }
      }
    }
    

    .publish-wrapper {
      margin-top: 1rem !important;
    }

    .column.left, .column {
      padding-right: 0;
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
  
    .column-article {
      display: flex;
      flex-direction: column-reverse;
    }
  }
  
  
  
  </style>
  